import type { IHrAccount } from "entities/document/lib/types/hr_person_types";

export const getEmployeeAccounts = (
    accounts: IHrAccount[],
    businessGroupName: string | undefined,
    assignmentNumber: string | null
): IHrAccount[] => {
    const priority = (account: IHrAccount): number => {
        const value = account.hr_account_priority;
        return value !== null && value !== undefined && Number.isFinite(Number(value))
            ? Number(value)
            : Number.POSITIVE_INFINITY;
    };
    const sortedAccounts = accounts
        .filter((account) => account.hr_business_group_name === businessGroupName
            && account.hr_assignment_number === assignmentNumber)
        .sort((left, right) => priority(left) - priority(right));

    let totalPercentage = 0;
    return sortedAccounts.filter((account) => {
        const percentage = Number(account.hr_account_percentage ?? 0);
        // These accounts remain available even after the percentage limit is reached.
        if (percentage === 0) {
            return true;
        }
        if (!Number.isFinite(percentage) || percentage < 0 || totalPercentage >= 100) {
            return false;
        }
        totalPercentage += percentage;
        return true;
    });
};
